export const getInsuranceCompanyByState = (usState) => (state) =>
  state.formPage.insuranceCompanies.find(
    (company) => company.state === usState,
  );
